<template>
  <div class="width100 margin-auto">
    <div class="width100 margin-top10 cursorpointer">
      <span class="attention f14" @click="dialogTable()"> 新 增 </span>
    </div>

    <table class="width100 margin-auto backwihte margin-top20">
      <tr class="hight40 f14" style="background: #e9e9e9">
        <th class="width5 borderf1">姓名</th>
        <th class="width5 borderf1">性别</th>
        <th class="width8 borderf1">出生年月</th>
        <th class="width12 borderf1">工作单位</th>
        <th class="width5 borderf1">部门</th>
        <th class="width8 borderf1">学历</th>
        <th class="width12 borderf1">专业</th>
        <th class="width8 borderf1">职称</th>
        <th class="width8 borderf1">本项目承担工作</th>
        <th class="width6 borderf1">工作量权重%</th>
        <th class="width9 borderf1">加入项目组时间</th>
        <th class="width9 borderf1">退出项目组时间</th>
        <th class="width5 borderf1">操作</th>
      </tr>
      <tr
        class="f14 hight40 textalign-center"
        v-for="(item, index) in page"
        :key="index"
      >
        <td class="borderf1 bordertopnone width5">
          {{ item.realname }}
        </td>
        <td class="table width5">
          {{ item.bind_info == null ? "" : item.bind_info.sex }}
        </td>
        <td class="table width8">
          {{ item.bind_info == null ? "" : item.bind_info.birthday }}
        </td>
        <td class="table width12">
          {{ item.bind_info == null ? "" : item.bind_info.company }}
        </td>
        <td class="table width5">
          {{ item.bind_info == null ? "" : item.bind_info.department }}
        </td>
        <td class="table width8">
          {{ item.bind_info == null ? "" : item.bind_info.qualification }}
        </td>
        <td class="table width12">
          {{ item.bind_info == null ? "" : item.bind_info.major }}
        </td>
        <td class="table width8">
          {{ item.bind_info == null ? "" : item.bind_info.rank }}
        </td>
        <td class="table width8 bluecolor">
          <el-input
            class="nullinput"
            :class="roleindex == index ? 'roleinput' : 'rolenullinput'"
            v-model="item.role"
            @blur="roleblur(index, $event)"
            @focus="rolefocus(index)"
          ></el-input>
        </td>
        <td class="table width6 bluecolor">
          <el-input
            type="number"
            max="100"
            min="1"
            oninput="if(value>100)value=100;if(value<0)value=0"
            class="nullinput"
            v-model="item.weight"
            :class="weightindex == index ? 'roleinput' : 'rolenullinput'"
            @focus="weightfocus(index)"
            @blur="weightblur(index, $event)"
          ></el-input>
        </td>
        <td class="table width9">
          <el-date-picker
            class="nullinput"
            style="width: 100%"
            v-model="item.start_date"
            type="date"
            placeholder="选择加入时间"
            value-format="yyyy-MM-dd"
            @change="starechange(index, $event)"
          >
          </el-date-picker>
        </td>
        <td class="table width9">
          <el-date-picker
            class="nullinput"
            style="width: 100%"
            v-model="item.end_date"
            type="date"
            placeholder="选择退出时间"
            value-format="yyyy-MM-dd"
            @change="endchange(index, $event)"
          >
          </el-date-picker>
        </td>
        <td
          class="table width5 cursorpointer bluecolor"
          @click="outProject(index)"
        >
          删除
        </td>
      </tr>
    </table>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 人员查找 -->
    <el-dialog
      title=""
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :show-close="true"
      :center="true"
      append-to-body
    >
      <div class="f16 width98 textalign-left dimensional">人员列表</div>
      <table class="width100 margin-auto backwihte margin-top20">
        <tr class="hight50" style="background: #e9e9e9">
          <th class="width10 borderf1">选择</th>
          <th class="width30 borderf1">用户信息</th>
          <th class="width15 borderf1">昵称</th>
          <th class="width15 borderf1">部门</th>
          <th class="width15 borderf1">最早登录IP</th>
          <th class="width15 borderf1">操作</th>
        </tr>
        <tr class="f14" v-for="(item, index) in pages" :key="index">
          <td class="borderf1 bordertopnone width10 pad-left10">
            <el-checkbox
              :true-label="item.user_id"
              :false-label="0"
              :label="item.user_id"
              @change="chexbox($event, index)"
            ></el-checkbox>
          </td>
          <td class="table hight50 width30 pad-left10">
            <div class="flex">
              <div class="avatar-picture borderf1">
                <img class="width100 hight40" :src="item.user.avatar" alt="" />
              </div>
              <div class="pad-left10">
                <p>{{ item.user.realname }}</p>
                <p>{{ item.user.mobile }}</p>
              </div>
            </div>
          </td>
          <td class="table width15 pad-left10">{{ item.user.nickname }}</td>
          <td class="table width15 pad-left10">{{ item.department }}</td>
          <td class="table width15 textalign-center">
            {{ item.user.last_ip }}
          </td>
          <td
            class="table width15 textalign-center cursorpointer bluecolor"
            @click="addpipo(index)"
          >
            加入项目
          </td>
        </tr>
      </table>
      <div class="margin-top20 textalign-right">
        <el-button @click="allAddpiponull()">取 消</el-button>
        <el-button type="primary" @click="allAddpipo()">批量添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  pipoSearch,
  outpipo,
  pipoList,
  enttechresearchdevelopmenteditprojectuser,
} from "@/api/Center/Center.api";
import { bindstafflist } from "@/api/loader/loder.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      page: "",
      pages: "",
      dialogTableVisible: false,
      centerNum: "",
      user_id: "",
      form: {
        desc: "",
      },
      as: [],
      userid: [],
      roleindex: -1,
      weightindex: -1,
    };
  },
  methods: {
    // 选择的id
    chexbox($event, index) {
      if ($event == 0) {
        this.userid.splice(this.userid.indexOf(this.pages[index].user_id), 1);
      } else {
        this.userid.push($event);
      }
    },
    allAddpiponull() {
      this.dialogTableVisible = false;
      this.userid = [];
    },
    // 批量添加
    allAddpipo() {
      if (this.userid.length == 0) {
        this.dialogVisiblenull = true;
        this.errormessage = "该用户已在项目中";
        return;
      } else {
        this.page.forEach((i) => {
          if (this.userid.indexOf(i.user_id) != -1) {
            this.userid.splice(this.userid.indexOf(i.user_id), 1);
          }
        });
        if (this.userid.length != 0) {
          pipoSearch({
            dev_project_id: this.centerNum,
            user_id: this.userid,
          }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
              this.userid = [];
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = "该用户已在项目中";
        }
      }
    },
    // 添加人员
    addpipo(index) {
      this.user_id = this.pages[index].user_id;
      const alluserid = [];
      this.page.forEach((i) => {
        alluserid.push(i.user_id);
      });
      if (alluserid.indexOf(this.user_id) != -1) {
        this.dialogVisiblenull = true;
        this.errormessage = "该用户已在项目中";
        return;
      } else {
        pipoSearch({
          dev_project_id: this.centerNum,
          user_id: this.user_id,
        }).then((res) => {
          if (res.data.code == 200) {
            this.refresh();
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 移出项目
    outProject(index) {
      this.$confirm("此操作将移除此成员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          outpipo({ id: this.page[index].id }).then((res) => {
            if (res.data.code == 200) {
              // this.refresh();
              pipoList({ dev_project_id: this.centerNum }).then((res) => {
                if (res.data.code == 200) {
                  this.page = res.data.data;
                } else {
                  this.dialogVisiblenull = true;
                  this.errormessage = res.data.msg;
                }
              });
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    dialogTable() {
      this.dialogTableVisible = true;
      bindstafflist({ all: 1 }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 人员列表刷新
    refresh() {
      this.$loading.show(); // 显示loading
      pipoList({ dev_project_id: this.centerNum }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.dialogTablesearch = false;
          this.dialogTableVisible = false;
          this.page = res.data.data;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    rolefocus(index) {
      this.roleindex = index;
    },
    roleblur(index, $event) {
      this.roleindex = -1;
      enttechresearchdevelopmenteditprojectuser({
        id: this.page[index].id,
        role: $event.target.value,
        weight: this.page[index].weight,
        end_date: this.page[index].end_date,
        start_date: this.page[index].start_date,
      }).then((res) => {
        if (res.data.code == 200) {
          // this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    weightfocus(index) {
      this.weightindex = index;
    },
    weightblur(index, $event) {
      this.weightindex = -1;
      enttechresearchdevelopmenteditprojectuser({
        id: this.page[index].id,
        weight: $event.target.value,
        role: this.page[index].role,
        end_date: this.page[index].end_date,
        start_date: this.page[index].start_date,
      }).then((res) => {
        if (res.data.code == 200) {
          // this.refresh();
          window.sessionStorage.setItem("weightb", $event.target.value);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    starechange(index, $event) {
      enttechresearchdevelopmenteditprojectuser({
        id: this.page[index].id,
        end_date: this.page[index].end_date,
        start_date: $event,
        role: this.page[index].role,
        weight: this.page[index].weight,
      }).then((res) => {
        if (res.data.code == 200) {
          // this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    endchange(index, $event) {
      enttechresearchdevelopmenteditprojectuser({
        id: this.page[index].id,
        end_date: $event,
        start_date: this.page[index].start_date,
        role: this.page[index].role,
        weight: this.page[index].weight,
      }).then((res) => {
        if (res.data.code == 200) {
          // this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.centerNum = window.sessionStorage.getItem("centerNums");
    pipoList({ dev_project_id: this.centerNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {},
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
}
th {
  padding: 0;
}
.lookup {
  width: 80px;
  border-radius: 5px;
  margin: 20px auto 0;
}
.preservation {
  width: 80px;
  height: 32px;
  line-height: 32px;
  border-radius: 5px;
}
.table {
  border: 1px solid #f1f1f1;
  border-left: none;
  border-top: none;
}
.avatar-picture {
  width: 40px;
  height: 40px;
}
.borderleftnone {
  border-left: none;
}
.bordertopnone {
  border-top: none;
}
.nullinput >>> .el-input__inner {
  border: none;
  height: 38px;
  color: #7b83ea;
}
.nullinput >>> .el-input__prefix {
  display: none;
}
.roleinput >>> .el-input__inner {
  border: 1px solid #7b83ea;
}
.rolenullinput >>> .el-input__inner {
  border: none;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>